// File System Access API utilities
// Requires Chrome 86+ or Edge 86+

export const isFileSystemAccessSupported = () => {
  return 'showOpenFilePicker' in window && 'showSaveFilePicker' in window;
};

export const saveFile = async (data, suggestedName = 'survey.cloudsam') => {
  if (!isFileSystemAccessSupported()) {
    throw new Error('File System Access API not supported. Please use Chrome or Edge.');
  }

  try {
    const fileHandle = await window.showSaveFilePicker({
      suggestedName,
      types: [
        {
          description: 'CloudSam Survey Files',
          accept: {
            'application/*': ['.cloudsam'],
          },
        },
        {
          description: 'JSON Files',
          accept: {
            'application/json': ['.json'],
          },
        },
      ],
    });

    const writable = await fileHandle.createWritable();
    await writable.write(JSON.stringify(data, null, 2));
    await writable.close();

    return fileHandle;
  } catch (error) {
    if (error.name === 'AbortError') {
      return null; // User cancelled
    }
    throw error;
  }
};

export const openFile = async () => {
  if (!isFileSystemAccessSupported()) {
    throw new Error('File System Access API not supported. Please use Chrome or Edge.');
  }

  try {
    const [fileHandle] = await window.showOpenFilePicker({
      types: [
        {
          description: 'CloudSam Survey Files',
          accept: {
            'application/*': ['.cloudsam'],
          },
        },
        {
          description: 'JSON Files',
          accept: {
            'application/json': ['.json'],
          },
        },
      ],
      multiple: false,
    });

    const file = await fileHandle.getFile();
    const contents = await file.text();
    
    return {
      data: JSON.parse(contents),
      fileHandle,
      fileName: file.name
    };
  } catch (error) {
    if (error.name === 'AbortError') {
      return null; // User cancelled
    }
    throw error;
  }
};

export const saveToExistingFile = async (fileHandle, data) => {
  if (!fileHandle) {
    throw new Error('No file handle provided');
  }

  try {
    const writable = await fileHandle.createWritable();
    await writable.write(JSON.stringify(data, null, 2));
    await writable.close();
    return true;
  } catch (error) {
    throw error;
  }
}; 